<ng-container *ngIf="orientation === 'vertical' else horizontal">
    <div class="d-flex align-items-start flex-column py-2 me-2">
        <ng-container *ngIf="meterType !== 'GROSS_PRODUCTION' else productionVertical">
        <app-connection-image [connectionType]="connectionType" [width]="width/1.2" style="margin-bottom: -5px"></app-connection-image>
        <ng-container *ngIf="meterType === 'PRIMARY' && virtual === true; else nonPrimary">
            <span class="d-flex flex-column align-items-center me-2">
                <span class="notranslate">Σ</span>
            </span>
        </ng-container>
        <ng-template #nonPrimary>
            <img *ngIf="meterType && meterType !== 'PRIMARY'" [src]="appContext.meterImage(meterType)" [width]="width/1.2"
                 class="me-2" [alt]="appContext.meterName(meterType)">
        </ng-template>
        </ng-container>
        <ng-template #productionVertical>
            <img src="assets/images/icons/renewable-energy.png"  [width]="width/1.2" class="me-2"
                 alt="Electricity production icon">
        </ng-template>
    </div>
</ng-container>
<ng-template #horizontal>
    <div class="d-flex align-items-center h-100 justify-content-center me-2">
        <ng-container *ngIf="meterType !== 'GROSS_PRODUCTION' else production">
            <app-connection-image [connectionType]="connectionType" [width]="width/1.2"></app-connection-image>
            <ng-container *ngIf="meterType === 'PRIMARY' && virtual === true; else nonPrimaryHorizontal">
            <span class="position-relative me-2">
                <span class="notranslate bi position-absolute bottom-0 end-0 fs-5 fw-semibold text-secondary" style="font-size: 0.60rem; margin-right: -5px; margin-bottom: -1px;">Σ</span>
            </span>
            </ng-container>
            <ng-template #nonPrimaryHorizontal>
                <img *ngIf="meterType && meterType !== 'PRIMARY'" [src]="appContext.meterImage(meterType)" [width]="width/1.2"
                     style="transform: rotate(90deg);" [alt]="appContext.meterName(meterType)">
            </ng-template>

        </ng-container>
        <ng-template #production>
            <img src="assets/images/icons/renewable-energy.png"  [width]="width/1.2" class="me-2"
                 alt="Electricity production icon">
        </ng-template>
    </div>
</ng-template>